import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72ff45c6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=72ff45c6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff45c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ff45c6')) {
      api.createRecord('72ff45c6', component.options)
    } else {
      api.reload('72ff45c6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=72ff45c6&scoped=true", function () {
      api.rerender('72ff45c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/title/index.vue"
export default component.exports